import { useCallback } from 'react';
import useLogin from 'hooks/auth/useLogin';
import useAuthFormSubmit from 'hooks/auth/useAuthFormSubmit';
import { toast } from 'react-toastify';
import { messageOf } from 'utils/error';
import LoginForm, { type TLoginFormSubmit } from '../components/auth/LoginForm';

export default function Login() {
  const login = useLogin();
  const handleSubmit = useAuthFormSubmit(login);

  const onSubmit: TLoginFormSubmit = useCallback(
    async (values, formikActions) => {
      try {
        await handleSubmit({ ...values, isAdmin: true }, formikActions);
      } catch (error) {
        toast.error(messageOf(error));
      }
    },
    [handleSubmit],
  );

  return <LoginForm onSubmit={onSubmit} />;
}
